//
// Segment analytics link tracking that includes experiment data.
// The Segment implementation allows a single element or an Array to be passed
// in, so we're keeping this as close as possible to this.
// See: https://segment.com/docs/sources/website/analytics.js/#track-link

import { getLinkTargetPath, getLinkTargetUrl } from '../dom';

export default function trackLink(trackable, event, params={}) {
    if (!trackable) return this;

    if (trackable instanceof global.Array) {
        trackable.forEach(el => setupTrackLink(el, event, params));

        return this;
    } else if (trackable instanceof window.NodeList) {
        for (var i = 0; i < trackable.length; i++) {
            setupTrackLink(trackable[i], event, params);
        }

        return this;
    } else {
        setupTrackLink(trackable, event, params);

        return this;
    }
}

function setupTrackLink(element, event, params) {
    const trackParams = window.trackParams || {};

    params = {
        url: window.location.href,
        target_path: getLinkTargetPath(element),
        target_url: getLinkTargetUrl(element, window.location),
        ...trackParams,
        ...params,
    };

    if (__DEV__) {
        element.addEventListener('click', () => {
            console.info('Track link: "%s": %o', event, params); // eslint-disable-line no-console
        });
    }

    if (window.analytics) {
        window.analytics.trackLink(element, event, params);
    }
}



// WEBPACK FOOTER //
// ./~/@99designs/utils/platform/trackLink.js